const participantTypes = {
    LOAD_WINNERS_STREAM: 'LOAD_WINNERS_STREAM',
    NEW_WINNERS_STREAM: 'NEW_WINNERS_STREAM',
    LOAD_STATS: 'LOAD_STATS',
}

export default participantTypes;
